<script setup lang="ts">
import PriceDisplay from '@/components/elements/PriceDisplay.vue'

export type SelectionSubtotalProps = {
  value: number
  label?: string
  note?: string
}

const props = withDefaults(defineProps<SelectionSubtotalProps>(), {
  label: 'Subtotal',
  note: 'Discounts and fees calculated at checkout',
})
</script>

<template>
  <div class="selection-subtotal">
    <hr class="divider" />

    <div class="total">
      <span>{{ label }}</span>

      <span aria-live="polite" class="amount">
        <PriceDisplay :value="props.value" />
      </span>
    </div>

    <p v-if="note" class="note">{{ note }}</p>
  </div>
</template>

<style scoped>
.selection-subtotal {
  display: flex;
  flex-direction: column;
  gap: var(--padding-comfy);
}

.divider {
  margin: 0;
  border: none;
  border-top: var(--divider);
}

.total {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--padding-compact);
  font-family: var(--font-family-body);
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-body);
  color: var(--text-primary);
}

.amount {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.note {
  font-size: var(--font-size-body-small);
  line-height: var(--line-height-body);
  text-align: center;
  color: var(--text-secondary);
}
</style>
